import { Typography } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Grid from "@material-ui/core/Grid"
import React, { useEffect, useState } from "react"

export default function ReleaseComponentsModal(props) {
  const { components, name, open, handleClose, algs } = props
  const [classOptionMap, setClassOptionMap] = useState({})

  useEffect(() => {
    if (algs) {
      const algsMap = {}
      for (const alg of algs) {
        if (alg.class_definitions) {
          algsMap[alg.alg_id.toString()] = alg.class_definitions
        } else {
          algsMap[alg.alg_id.toString()] = []
        }

        algsMap[alg.alg_id.toString()].push({
          class_id: 99,
          label: "empty",
        })
      }
      setClassOptionMap(algsMap)
    }
  }, [algs])

  const setToClasses = (algId, classIds) => {
    if (
      classOptionMap &&
      Object.keys(classOptionMap).includes(algId.toString()) &&
      (algId || algId === 0) &&
      classIds &&
      classIds.length > 0
    ) {
      return classIds
        .map(
          (id) =>
            classOptionMap[algId.toString()].find(
              (classObject) => classObject.class_id.toString() === id.toString(),
            )?.label,
        )
        .join(", ")
    }
    return "None"
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Release: {name}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {components && components.length > 0
            ? components.map((component) => {
                return (
                  <Grid key={component.algMetadataId} item xs={12}>
                    <Typography variant="body1">{`Model ID: ${component.algMetadataId}`}</Typography>
                    <Typography variant="body1">{`Is Intermediate?: ${component.isIntermediate}`}</Typography>
                    <Typography variant="body1">{`Save Bound Box Images?: ${component.saveBBImages}`}</Typography>
                    <Typography variant="body1">{`Save Cropped Images?: ${component.saveCroppedImages}`}</Typography>
                    <Typography variant="body1">{`Downstream Model IDs: ${component.downstreamConfigs.length === 0 ? "None" : component.downstreamConfigs.join(", ")}`}</Typography>
                    <Typography variant="body1">{`Bypass Class IDs: ${setToClasses(component.algMetadataId, component.bypassClasses)}`}</Typography>
                    <Typography variant="body1">{`Ignore Class IDs: ${setToClasses(component.algMetadataId, component.ignoredClasses)}`}</Typography>
                    <Typography variant="body1">{`Image Normalization Method: ${component.imageNormalizationMethod}`}</Typography>
                    <Typography variant="body1">{`Sensitivity: ${component.sensitivity}`}</Typography>
                  </Grid>
                )
              })
            : []}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
